<template>
  <section
    v-if="showSection"
    class="subscribe-section"
  >
    <div class="container">
      <form @submit.prevent="subscribe">
        <div class="box">
          <div class="title-wrapper">
            <h2 class="title">
              Start creating your
              <br />
              future career now
            </h2>
            <p class="subtitle">
              Subscribe to our newsletter and be the first to hear about new
              opportunities.
            </p>
          </div>
          <div class="input-wrapper">
            <input
              v-model="email"
              placeholder="Enter your email"
              type="email"
              class="input-email"
              :class="{
                'input-error': !isValidEmail || error,
                'input-success': showSuccessMessage,
              }"
            />

            <p
              v-if="showSuccessMessage"
              class="feedback-message success-message"
            >
              Your email has been successfully added to our mailing list.
            </p>
            <p
              v-else
              class="feedback-message error"
            >
              {{ errorMessage }}
            </p>
          </div>
          <button
            :disabled="pending"
            class="proxify-btn proxify-btn-no-icon subscribe-button"
          >
            <spinner-icon v-if="pending"></spinner-icon>
            Subscribe Now
          </button>
          <p class="spam-text">
            We promise to never spam you. Read our
            <nuxt-link to="/privacy">privacy policy</nuxt-link>
          </p>
        </div>
        <NuxtPicture
          src="/images/home-page/subscribe/image.png"
          alt="subscribe image"
          lazy
        />
      </form>
    </div>
  </section>
</template>

<script>
import SpinnerIcon from '~/components/Common/Svg/SpinnerIcon';
import slugRouteName from '~/mixins/slugRouteName';
import subscribe from '../../subscribe';

export default {
  components: {
    SpinnerIcon,
  },
  mixins: [subscribe, slugRouteName],
};
</script>

<style lang="scss" scoped>
@import './SubscribeForm.scss';
</style>
